import instance from './instance';

export const fetchUpdateAiReports = () => instance.get('/update_ai_reports');

export const createUpdateAiReportSections = ({ slug, data }) =>
  instance.post(`/update_ai_reports/${slug}/generate_sections`, data);

export const cancelGeneratingAiReportSections = ({ slug, data }) =>
  instance.patch(`/update_ai_reports/${slug}/cancel_generating_sections`, data);

export const fetchUpdateAiReport = ({ slug }) => instance.get(`/update_ai_reports/${slug}`);

export const updateUpdateAiReport = ({ slug, data }) => instance.patch(`/update_ai_reports/${slug}`, data);

export const deleteUpdateAiReport = ({ slug }) => instance.delete(`/update_ai_reports/${slug}`);
